import { render } from "./MyInstitutions.vue?vue&type=template&id=608186dc&lang=pug"
import script from "./MyInstitutions.vue?vue&type=script&setup=true&lang=js"
export * from "./MyInstitutions.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__